// @src/pages/Home.jsx
const Home = () => {
    return (
      <div style={{ 
        display: "flex", 
        alignItems: "center",
        flexDirection: "column", 
        justifyContent: "center",
        height: "100vh"  
        }}>
        <img src='/assets/logo.png' alt="Iguana GIFT" />
        <h1>Bienvenido a Iguana GIFT</h1>
      </div>
    );
  };
  export default Home;